import { getSignatureForContact } from '../../graphql/queries';
import {
  GET_SIGNATURE_DATA_ABORTED,
  GET_SIGNATURE_DATA_REQUESTED,
  GET_SIGNATURE_DATA_COMPLETED,
  GET_SIGNATURE_DATA_FAILED,
} from './types';
import api from '../../services/api';
import debug from '../../services/debug';

/**
 * Get client signature
 *
 * @param {string=} contactId - Optional contact ID to set signature
 * @param {string=} resourceId - Optional resource ID to allow guests to set sigratures
 * @param {string} [authMode=userPool] - Authentication mode to use for request
 */
const getSignature =
  (contactId, resourceId, authMode = 'userPool') =>
  async (dispatch, getState) => {
    const { contacts, signatureData } = getState();
    const { ContactID } = contacts.get('set');

    const signatureDataHolder = signatureData.get('data');

    if (signatureDataHolder) {
      dispatch({
        type: GET_SIGNATURE_DATA_ABORTED,
      });

      return;
    }
    dispatch({
      type: GET_SIGNATURE_DATA_REQUESTED,
    });

    try {
      const { data } = await api.graphql({
        authMode,
        query: getSignatureForContact,
        variables: {
          ContactID: contactId ?? ContactID,
          ResourceId: resourceId,
        },
      });

      dispatch({
        type: GET_SIGNATURE_DATA_COMPLETED,
        payload: data.getSignatureForContact,
      });
    } catch (err) {
      debug(GET_SIGNATURE_DATA_FAILED, err);

      dispatch({
        type: GET_SIGNATURE_DATA_FAILED,
        payload: err,
      });
    }
  };

export default getSignature;
